/**
 * Local types shared by the composer surface (WEB-2).
 *
 * These describe editor-side state only — anything crossing the wire uses the
 * contracts in `shared/api.ts`.
 */

import type { PlatformId, PlatformPostMedia, PlatformPostMeta } from '../../../shared/types';

/** The three editable parts of one platform variant. */
export interface DraftValue {
  content: string;
  meta: PlatformPostMeta;
  media: PlatformPostMedia[];
}

/** Autosave lifecycle for a single variant. */
export type SaveState = 'clean' | 'dirty' | 'saving' | 'saved' | 'error';

/**
 * Router state accepted by `/composer`. The dashboard deep-links ideas here and
 * the calendar deep-links an empty day; both are optional and best-effort.
 */
export interface ComposerPrefill {
  prefillTopic?: string;
  prefillAngle?: string;
  prefillHook?: string;
  prefillPlatforms?: PlatformId[];
  /** ISO-8601 UTC — pre-fills the schedule pickers. */
  prefillScheduledAt?: string;
}

export function isDraftEqual(a: DraftValue, b: DraftValue): boolean {
  return (
    a.content === b.content &&
    JSON.stringify(a.meta) === JSON.stringify(b.meta) &&
    JSON.stringify(a.media) === JSON.stringify(b.media)
  );
}
